import { useState } from "react";

const MOMENTS = {
  chapter_1: [["Reception", "office:npc:200"], ["First dinner", "dining:event:dinner"], ["Station N-1", "trail_north:npc:836"], ["Fireside talk", "living:event:fireside"],
    ["Station C-2", "trail_creek:npc:756"], ["Station M-3", "trail_mine:npc:816"], ["Cave plan", "living:event:plan"], ["Into the cave", "cave_tunnel:event:enter"], ["Chapter end", "cave_tunnel:event:end"]],
  chapter_2: [["Fireside council", "living:event:council"], ["Radio call", "den:npc:52"], ["The drinking", "trail_north:npc:420"], ["Earthquake", "trail_north:event:quake"],
    ["Samantha", "living:event:knock"], ["The wolves", "living:event:wolves"], ["The iron key", "cave_bottom:npc:462"], ["Chapter end", "living:event:ch2end"]],
  chapter_3: [["Down the stairs", "iron_stairs:event:open"], ["The chamber", "chamber:event:dagger"], ["The cult", "chamber:event:cult"], ["Back to Joe", "living:event:joe3"],
    ["The batteries", "outside:npc:176"], ["Dana agrees", "chamber:event:agree"], ["The ritual", "chamber:event:ritual"], ["Can you feel it", "living:event:feel"], ["The end", "outside:event:final"]],
};

const Bar = ({ label, n, max, base, testid }) => (
  <div className="grid grid-cols-[130px_1fr_70px] sm:grid-cols-[160px_1fr_90px] items-center gap-3" data-testid={testid}>
    <span className="text-[#9CA3AF] truncate">{label}</span>
    <div className="h-4 bg-[#1f2430]"><div className="h-4 bg-[#DC2626] transition-[width] duration-500" style={{ width: `${max ? (n / max) * 100 : 0}%` }} /></div>
    <span className="text-[#F3F4F6] text-right">{n}{base ? <span className="text-[#475569]"> · {Math.round((n / base) * 100)}%</span> : null}</span>
  </div>
);

export const DropOffChart = ({ players }) => {
  const [ch, setCh] = useState("chapter_1");
  const saves = players.map((u) => u.progress[ch]).filter(Boolean);
  const rows = [["Started", saves.length], ...MOMENTS[ch].map(([l, id]) => [l, saves.filter((p) => p.notes.includes(id)).length])];
  const max = Math.max(1, ...rows.map((r) => r[1]));
  return (
    <section className="mt-8" data-testid="admin-dropoff">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <p className="font-blocky text-[10px] text-[#DC2626] tracking-widest">STORY DROP-OFF</p>
        <div className="flex gap-2">
          {Object.keys(MOMENTS).map((c) => (
            <button key={c} onClick={() => setCh(c)} className={`pixel-btn ${ch === c ? "" : "ghost"} !py-1`} data-testid={`admin-dropoff-tab-${c}`}>{c.replace("chapter_", "Ch ")}</button>
          ))}
        </div>
      </div>
      <div className="border-2 border-[#2E3440] bg-[#0A0B10] p-4 space-y-2">
        {rows.map(([l, n], i) => <Bar key={l} label={l} n={n} max={max} base={rows[0][1]} testid={`admin-dropoff-row-${i}`} />)}
      </div>
    </section>
  );
};

const dayKey = (s) => (s ? s.slice(0, 10) : null);

export const DailyChart = ({ players, sales }) => {
  const signups = {}, sold = {};
  players.forEach((u) => { const k = dayKey(u.created_at); if (k) signups[k] = (signups[k] || 0) + 1; });
  sales.forEach((s) => { const k = dayKey(s.date); if (k) sold[k] = (sold[k] || 0) + 1; });
  const keys = [...Object.keys(signups), ...Object.keys(sold)].sort();
  const days = [];
  if (keys.length) for (let d = new Date(keys[0] + "T00:00:00Z"); dayKey(d.toISOString()) <= dayKey(new Date().toISOString()); d.setUTCDate(d.getUTCDate() + 1)) days.push(dayKey(d.toISOString()));
  const max = Math.max(1, ...days.map((d) => Math.max(signups[d] || 0, sold[d] || 0)));
  return (
    <section className="mt-8" data-testid="admin-daily">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <p className="font-blocky text-[10px] text-[#DC2626] tracking-widest">DAILY SIGNUPS & SALES</p>
        <div className="flex gap-4 text-[#9CA3AF]"><span><span className="inline-block w-3 h-3 bg-[#7DD3FC] mr-1" />signups</span><span><span className="inline-block w-3 h-3 bg-[#DC2626] mr-1" />sales</span></div>
      </div>
      <div className="border-2 border-[#2E3440] bg-[#0A0B10] p-4 overflow-x-auto">
        {!days.length && <p className="text-[#64748B]" data-testid="admin-daily-empty">No activity yet.</p>}
        <div className="flex items-end gap-3 h-48 min-w-max">
          {days.map((d) => (
            <div key={d} className="flex flex-col items-center gap-1 h-full justify-end" data-testid={`admin-daily-${d}`}>
              <div className="flex items-end gap-0.5 flex-1">
                <div className="w-3 bg-[#7DD3FC]" style={{ height: `${((signups[d] || 0) / max) * 100}%` }} title={`${signups[d] || 0} signups`} />
                <div className="w-3 bg-[#DC2626]" style={{ height: `${((sold[d] || 0) / max) * 100}%` }} title={`${sold[d] || 0} sales`} />
              </div>
              <span className="text-[#F3F4F6] text-base leading-none">{signups[d] || 0}/{sold[d] || 0}</span>
              <span className="text-[#475569] text-base leading-none">{d.slice(5)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
